import {Button, Typography} from '@mui/material';
import styles from './RoamingProductEU.module.scss';

const RoamingProductEU = ({ euProductInfo }) => {
  if (!euProductInfo) {
    return null;
  }

  const [freeRoamingCard = {}, myInternetCard = {}] = euProductInfo.cards || [];

  return (
    <div className={styles.container}>
      <div className="w-100">
        <Typography component="div" variant="h4">{euProductInfo.title}</Typography>
      </div>
      <div className="d-flex flex-column flex-md-row gap-3">
        <div className="w-100 w-md-auto">
          <div className={styles.plan}>
            <div className={styles.planTop}>
              <Typography component="div" variant="h5" className="pb-3">{freeRoamingCard.title}</Typography>
              <div className={styles.characteristicContainer}>
                {(freeRoamingCard.characteristics || []).map((characteristic) => (
                  <div key={characteristic.title} className={styles.characteristic}>
                    <img
                      src={characteristic.svg.url}
                      alt={characteristic.svg.alt}
                      className={styles.characteristicIcon}
                    />
                    <div className={styles.characteristicInfo}>
                      <Typography component="div" variant="subtitle1">{characteristic.title}</Typography>
                      <Typography component="div" variant="body2">{characteristic.description}</Typography>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.planBottom}>
              <Button
                disableRipple
                disableFocusRipple
                disableTouchRipple
                disableElevation
                type="button"
                variant="contained"
                className="rounded-5 px-4 py-2 w-100"
                sx={{
                  ':focus': { outline: 'none' },
                  ':focus-visible': { outline: '2px solid black', outlineOffset: '3px' },
                }}
                href={freeRoamingCard.buttonUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {freeRoamingCard.buttonLabel}
              </Button>
            </div>
          </div>
        </div>
        <div className="w-100 w-md-auto">
          <div className={styles.plan}>
            <div className={styles.planTop}>
              <Typography component="div" variant="h5" className="pb-3">{myInternetCard.title}</Typography>
              <Typography component="div" variant="body1" className="pb-3">{myInternetCard.description}</Typography>
            </div>
            <div className={styles.planBottom}>
              <Button
                disableRipple
                disableFocusRipple
                disableTouchRipple
                disableElevation
                type="button"
                variant="contained"
                className="rounded-5 px-4 py-2 w-100"
                sx={{
                  ':focus': { outline: 'none' },
                  ':focus-visible': { outline: '2px solid black', outlineOffset: '3px' },
                }}
                href={myInternetCard.buttonUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {myInternetCard.buttonLabel}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoamingProductEU;
